import type { Option } from 'platform/components';
import type { Nullish } from 'shared/web';
import type { DefinitionResponseBody, GetSmartSearchResponse, SuggestionsOptions, SuggestionsResponseBody, TransformedDefinitionApiResponse } from '../types/Api';
import type { EagColumnGroup } from '../types/EagColumnGroup';
const transformDefinitionResponse = (definition: DefinitionResponseBody): TransformedDefinitionApiResponse => ({
  ...definition,
  groups: definition.columnGroups.reduce((accumulator, group) => {
    accumulator[group.key] = {
      groupId: group.key,
      headerName: group.title,
      children: []
    };
    return accumulator;
  }, {} as Record<string, EagColumnGroup>)
});
const transformSuggestionOptionsResponse = (data: SuggestionsResponseBody): SuggestionsOptions => data.suggestions.map(option => ({
  label: option.label,
  value: option.key
}));
const transformSmartSearchResponse = (data: Nullish | GetSmartSearchResponse): Option[] => data?.queries ? data.queries?.map(({
  query
}) => ({
  label: query,
  value: query
})) : [];
export const transformations = {
  transformDefinitionResponse,
  transformSuggestionOptionsResponse,
  transformSuggestionLabelsResponse: transformSuggestionOptionsResponse,
  transformSmartSearchResponse
};